module.exports = __webpack_public_path__ + "img/startConfigurationEarrings@2x.a231c5b.webp";